// Textos de las reservas de grupo de Taxi / VTC: pantallas de la empresa
// (listado, detalle, asistente y justificante) y mesa de WAIIS. Se registran
// junto al resto de vocabularios en AppComponent.
export const locale = {
  lang: 'en',
  data: {
    RIDE_BOOKINGS: {
      STATUS: {
        REQUESTING: 'Booking',
        CANCELLING: 'Cancelling',
        SCHEDULED: 'Scheduled',
        FAILED: 'Failed',
        REQUESTED: 'Requested',
        CONFIRMED: 'Confirmed',
        IN_PROGRESS: 'In progress',
        COMPLETED: 'Completed',
        CANCELLED: 'Cancelled',
      },
      VEHICLE_STATUS: {
        PENDING: 'Queued',
        REQUESTING: 'Booking',
        BOOKED: 'Booked',
        FAILED: 'Not booked',
        NEEDS_ATTENTION: 'Needs review',
        CANCELLED: 'Cancelled',
      },
      FAILURE_REASON: {
        PRICE_ABOVE_MAX: 'The price went above the maximum',
        PRODUCT_UNAVAILABLE: 'The product is no longer available',
        FARE_EXPIRED: 'The quote has expired',
        SURGE: 'The provider is applying surge pricing at that time',
        SCHEDULED_AT_OUT_OF_RANGE: 'The provider does not accept bookings for that time',
        PASSENGER_PHONE_MISSING: 'The lead passenger has no phone number',
        HOLD_FAILED: 'The amount could not be held',
        PROVIDER_TRIP_FAILED: 'The provider did not confirm the ride',
        PROVIDER_TRIP_REJECTED: 'The provider rejected the ride',
        PASSENGER_PHONE_INVALID: "The lead passenger's phone number is not valid",
        UNEXPECTED_ERROR: 'Unexpected error',
        ATTEMPT_INTERRUPTED: 'The attempt was interrupted',
      },
      HOLD: {
        PENDING: 'Holding the amount',
        HELD: 'Amount held',
        FAILED: 'Hold failed',
      },
      CATEGORY: {
        ECONOMY: 'Economy',
        EXECUTIVE: 'Executive',
        VAN: 'Van',
      },
      SERVICE: {
        ANY: 'Taxi or VTC',
        TAXI: 'Taxi only',
        VTC: 'VTC only',
      },
      CANCELLED_BY: {
        COMPANY: 'Cancelled by the company',
        WAIIS: 'Cancelled by WAIIS',
        SYSTEM: 'Cancelled automatically',
      },
      MONEY_REASON: {
        INSUFFICIENT_AVAILABLE_BALANCE: 'There is not enough balance in the company wallet',
        TOP_UP_FAILED: 'The top-up from the company card failed',
        ALREADY_SETTLED: 'The booking was already settled',
        ERROR: 'Unexpected error while moving the money',
      },
      EVENT: {
        REQUESTED: 'Booking requested',
        HOLD_SUCCEEDED: 'Maximum amount held',
        HOLD_FAILED: 'The amount could not be held',
        CONFIRMED: 'Confirmed by WAIIS',
        VEHICLES_ASSIGNED: 'Vehicles assigned',
        STARTED: 'In progress',
        COMPLETED: 'Completed',
        SETTLED: 'Charge confirmed',
        SETTLEMENT_FAILED: 'The charge failed',
        SETTLEMENT_RETRIED: 'Charge retried',
        CANCELLED: 'Cancelled',
        CANCELLATION_REQUESTED: 'Cancellation requested',
        CANCELLATION_FAILED: 'Not every ride could be cancelled',
        RIDE_STARTED: 'Vehicle {{position}}: ride started',
        RIDE_COMPLETED: 'Vehicle {{position}}: ride completed',
        RIDE_CANCELLED: 'Vehicle {{position}}: ride cancelled',
        RIDE_FAILED: 'Vehicle {{position}}: the ride did not go ahead',
        SETTLEMENT_REQUESTED: 'Charge requested',
        UNKNOWN: 'Booking update',
        VEHICLE_BOOKED: 'Vehicle {{position}} booked',
        VEHICLE_ATTEMPT_FAILED: 'Vehicle {{position}}: attempt failed',
        VEHICLE_FAILED: 'Vehicle {{position}} not booked',
        VEHICLE_NEEDS_ATTENTION: 'Vehicle {{position}} needs review',
        VEHICLES_RESOLVED: 'Booking resolved',
        VEHICLES_RESOLVED_COUNTS: '{{booked}} booked, {{failed}} failed, {{needsAttention}} to review',
        REQUESTED_AMOUNT: 'Estimated maximum {{amount}}',
        COMPLETED_AMOUNT: 'Total {{amount}}',
        SETTLED_AMOUNT: '{{amount}} charged',
        RETRIED_AMOUNT: '{{amount}} will be charged again',
        VEHICLES_COUNT: '{{count}} vehicles',
        VEHICLES_COUNT_ONE: '1 vehicle',
        NO_COST: 'No cost',
        FEE: 'Cancellation fee {{amount}}',
        RIDE_AMOUNT: 'Amount {{amount}}',
        SETTLEMENT_AMOUNT: '{{amount}} to be charged',
        VEHICLES_NOT_CANCELLED: 'Not cancelled: vehicle {{positions}}',
      },
      FIELD: {
        PICKUP: 'Pick-up',
        CONCEPT: 'Description',
        COST_CENTER: 'Cost centre',
        OFFICE: 'Office',
        ORIGIN: 'Origin',
        DESTINATION: 'Destination',
        ROUTE: 'Route',
        PASSENGERS: 'People',
        VEHICLES: 'Vehicles',
        CATEGORY: 'Vehicle type',
        NOTES: 'Internal notes',
        AMOUNT: 'Amount',
        STATUS: 'Status',
        CORPORATION: 'Company',
        CREATED_BY: 'Created by',
        DATE: 'Date',
      },
      VEHICLES_OF: '{{count}} × {{category}}',
      VEHICLES_BOOKED: '{{booked}} of {{total}} booked',
      PEOPLE: '{{count}} people',
      PEOPLE_ONE: '1 person',
      ESTIMATE_RANGE: '{{min}} – {{max}}',
      RIDE_CANCELLED: 'Cancelled',
      ESTIMATED: 'estimated',
      HELD_MAX: 'maximum held',
      NO_COST: 'No cost',
      FEE: 'cancellation fee',
      CHARGE_FAILED: 'Charge failed',
      OPEN: 'Open',
      RETRY: 'Retry',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      ACCEPT: 'Accept',
      CANCEL: 'Cancel',
      BACK: 'Back',
      ALL_STATUSES: 'All statuses',
      FROM: 'From',
      TO: 'To',
      PAGINATION: 'Showing {{shown}} of {{total}} bookings',
      LOAD_ERROR: 'The bookings could not be loaded.',
      FORBIDDEN: 'You do not have permission to view this company’s bookings.',
      TODAY: 'Today',
      TOMORROW: 'Tomorrow',

      COST_CENTERS: {
        TITLE: 'Cost centres',
        SUB: 'To allocate group bookings. Optional.',
        ADD: 'Add',
        NAME: 'Cost centre name',
        SAVING: 'Adding…',
        EMPTY: 'No cost centres yet.',
        DUPLICATE: 'There is already a cost centre with that name.',
        SAVE_ERROR: 'The cost centre could not be added.',
        LOAD_ERROR: 'The cost centres could not be loaded.',
        REMOVE: 'Remove',
        REMOVE_TITLE: 'Remove “{{name}}”',
        REMOVE_TEXT: 'Bookings that already use it keep their label.',
        REMOVING: 'Removing…',
        REMOVED: 'Removed',
        REMOVE_ERROR: 'The cost centre could not be removed',
      },

      QUICK: {
        FAB: 'Book a taxi',
        TITLE: 'Booking for a group or event',
        SUB: 'To leave right now, the employee uses the app',
        ORIGIN: 'Origin · office or address',
        DESTINATION: 'Destination',
        CONTINUE: 'Continue with the booking',
        MAP_BOOKING: '{{concept}} · {{when}}',
      },

      KPI: {
        NEXT: 'Next booking',
        NO_NEXT: 'No upcoming bookings',
        VEHICLES: '{{count}} vehicles',
        VEHICLES_ONE: '1 vehicle',
        PENDING: 'Being booked or to review',
        PENDING_HINT: 'Being booked or with a vehicle that needs review',
        ALL_CONFIRMED: 'All booked',
        SPENT: 'Bookings · last 30 days',
        COMMITTED: 'Committed in upcoming: {{amount}}',
      },

      LIST: {
        ALL_OFFICES: 'All offices',
        TITLE: 'Group bookings',
        NEW: 'New booking',
        EMPTY_TITLE: 'No bookings yet',
        EMPTY_NONE: 'Create the first one for an event, a visit or a group.',
        EMPTY_FILTERED: 'No booking matches the filters.',
        CREATED: 'Booking created: we are booking the vehicles',
        ACTIONS: 'Actions',
        DETAILS: 'Details',
        EMPTY_FILTERED_TITLE: 'No results',
      },

      DETAIL: {
        BACK_TO_LIST: 'Back to the list',
        NOT_FOUND: 'This booking does not exist or belongs to another company.',
        LOAD_ERROR: 'The booking could not be loaded.',
        PRICE: 'Amount',
        ESTIMATE: 'Estimated price',
        COMMISSION_INCLUDED: 'Includes a {{pct}} % WAIIS fee',
        UNKNOWN_PASSENGER: 'Person no longer on the staff list',
        NO_VEHICLES: 'WAIIS assigns the provider and the vehicles on confirmation.',
        VEHICLE: 'Vehicle {{n}}',
        PROVIDER: 'Provider',
        DRIVER: 'Driver',
        PLATE: 'Licence plate',
        VEHICLE_AMOUNT: 'Amount',
        HISTORY: 'History',
        PICKUP_FUTURE: 'Pick-up',
        RECEIPT: 'View receipt',
        CANCEL: 'Cancel booking',
        NOTE_HOLD_PENDING_TITLE: 'Holding the maximum amount',
        NOTE_HOLD_PENDING: 'In a few seconds {{amount}} will be held in the company wallet. If the balance is insufficient, it is topped up from the company card.',
        NOTE_REQUESTED_TITLE: 'Awaiting confirmation from WAIIS',
        NOTE_REQUESTED: 'You will receive an email once it is confirmed.',
        NOTE_HOLD_FAILED_TITLE: 'Cancelled: the amount could not be held',
        NOTE_CANCELLED_BY_WAIIS_TITLE: 'WAIIS has cancelled the booking',
        NOTE_CHARGE_FAILED_TITLE: 'The charge failed',
        NOTE_CHARGE_FAILED: 'WAIIS will retry it. In the meantime the company cannot make new bookings or pay for employee trips.',
        CLOSE: 'Close',
        PRICE_FINAL: 'final · estimated {{range}}',
        PRICE_HELD: 'estimated · {{amount}} held',
        PRICE_TOTAL_HELD: 'total of the rides · maximum held {{amount}}',
        NO_COST_LOWER: 'no charge',
        VEHICLES_TITLE: 'Vehicles · {{count}} × {{category}} · {{service}}',
        DRIVER_PENDING: 'driver and plate to be assigned',
        REPEAT: 'Repeat booking',
        BOOK_AGAIN: 'Book again',
        VEHICLES_TITLE_PRODUCT: 'Vehicles · {{count}} × {{product}}',
        TITULAR: 'Account holder: {{name}}',
        VEHICLE_ATTEMPTS: '{{count}} attempts',
        VEHICLE_ATTEMPTS_ONE: '1 attempt',
        VEHICLE_NEEDS_ATTENTION: 'The provider could not confirm whether the ride was created: check its panel before booking again',
        NOTE_REQUESTING_TITLE: 'We are booking the vehicles…',
        NOTE_REQUESTING: 'This booking refreshes itself in the meantime.',
        NOTE_FAILED_TITLE: 'No vehicle could be booked',
        NOTE_FAILED: 'Each vehicle shows why. You can book again.',
      },

      WIZARD: {
        TITLE: 'New booking',
        SUB: 'One Uber, Cabify or Bolt ride per vehicle, with an employee as the account holder. The company pays.',
        STEPS_ARIA: 'Booking steps',
        STEP_TRIP: 'Route',
        STEP_PRODUCT: 'Product',
        STEP_POINTS: 'Pickup and drop-off',
        STEP_PASSENGERS: 'Passengers',
        STEP_SUMMARY: 'Confirm',
        CONCEPT_PLACEHOLDER: 'Team dinner, client visit…',
        CONCEPT_REQUIRED: 'Enter a description.',
        ADDRESS_REQUIRED: 'Choose an address from the list.',
        PICKUP_HINT: 'Madrid time.',
        PICKUP_REQUIRED: 'Enter the pickup date and time.',
        PICKUP_PAST: 'The pickup must be in the future.',
        PASSENGERS_RANGE: 'Between 1 and 60 people.',
        PASSENGERS_COUNT: 'Number of people',
        PEOPLE_UNIT: 'people',
        ORIGIN_PLACEHOLDER: 'Office or address',
        DESTINATION_PLACEHOLDER: 'Address, airport, hotel…',
        DATE: 'Date',
        TIME: 'Pickup time',
        OPTIONAL_LOWER: 'optional',
        COST_CENTERS_UNAVAILABLE: 'Cost centres are added in Settings.',
        NO_COST_CENTER: 'Not assigned',
        NO_OFFICE: 'No office',
        QUOTE_ERROR: 'The route could not be quoted.',
        FARE_EXPIRED: 'The quote has expired: choose the product again.',
        PRODUCT_REQUIRED: 'Choose a product.',
        PRODUCT_VEHICLES: '{{count}} vehicles with {{seats}} seats',
        PRODUCT_VEHICLES_ONE: '1 vehicle with {{seats}} seats',
        ETA: 'arrives in {{minutes}} min',
        PER_VEHICLE: '{{range}} per vehicle',
        TOTAL: 'Total',
        NO_SCHEDULING: 'Cannot be booked in advance',
        TOO_MANY_VEHICLES: 'More than {{max}} vehicles: split the group into several bookings',
        POINTS_PICKUP: 'Pickup',
        POINTS_DROPOFF: 'Drop-off',
        ADDRESS_OPTION: 'The chosen address',
        POINTS_NONE: 'The provider has no points here: the chosen address is used.',
        MAP_LABEL: 'Trip map',
        TITULAR_HINT: 'The first person in each vehicle is the ride’s account holder.',
        ADD_GROUP: 'Add a group',
        ADD_PEOPLE: 'Add people',
        VEHICLE: 'Vehicle {{n}}',
        SEATS_USED: '{{count}} of {{seats}} seats',
        TITULAR: 'Account holder',
        MAKE_TITULAR: 'Make account holder',
        TITULAR_NAME: 'Account holder: {{name}}',
        IN_VEHICLE: 'In vehicle {{n}}',
        VEHICLE_EMPTY: 'Add at least one person: the first one is the account holder.',
        GROUP_OVERFLOW: '{{count}} people from {{group}} do not fit in the vehicles.',
        GROUP_OVERFLOW_ONE: '1 person from {{group}} does not fit in the vehicles.',
        REMOVE: 'Remove',
        SEARCH_PEOPLE: 'Search by name or department…',
        SEARCH_GROUPS: 'Search group…',
        PEOPLE_NONE: 'Nobody with that name.',
        GROUPS_NONE: 'No groups with that name.',
        ESTIMATE: 'Estimated price',
        COMMISSION: 'Includes a {{pct}} % WAIIS fee',
        HOLD_MAX: 'The maximum is held: {{amount}}',
        SUMMARY: 'Summary',
        WHEN: 'When',
        PRODUCT: 'Product',
        NOTES_PLACEHOLDER: 'E.g. event reference, contact person…',
        NOTES_HINT: 'Only your company sees them: they are not sent to the drivers.',
        PAYMENT: 'Payment',
        PAY_HOLD: 'Maximum amount to hold',
        PAY_WALLET: 'Company wallet · available balance',
        PAY_TOP_UP: 'Not enough balance · topped up from {{card}}',
        PAY_NO_CARD: 'Not enough balance and no company card: the booking cannot be held.',
        PAY_INSUFFICIENT: 'Not enough balance and the policy has no automatic top-up: the booking cannot be held.',
        NOT_ALLOWED: {
          FLAG_DISABLED: 'Group bookings are not enabled for your company.',
          PLAN_LOCKED: 'Your plan does not include group bookings.',
          POLICY_INACTIVE: 'The company’s travel policy is not active.',
          CORPORATE_DEBT: 'The company has outstanding payments: bookings are blocked until they are settled.',
          BUDGET_EXHAUSTED: 'The company’s travel budget has run out.',
        },
        CONTINUE: 'Continue',
        SUBMIT: 'Book',
        SUBMITTING: 'Booking…',
        SUBMIT_ERROR: 'The booking could not be made.',
      },

      CANCEL_DIALOG: {
        TITLE: 'Cancel the booking',
        TEXT: '“{{concept}}”, with pick-up on {{pickup}}.',
        FREE: 'No charge: the held amount ({{amount}}) is released.',
        PROVIDER_POLICY: 'Each ride is cancelled under its provider’s policy and may carry a fee.',
        LATE: 'Less than {{hours}} h to go: it costs {{amount}} ({{pct}} % of the maximum estimate). The rest is released.',
        CONFIRM: 'Cancel booking',
        SAVING: 'Cancelling…',
        DONE: 'Cancelled',
        ERROR: 'The booking could not be cancelled',
        NOT_CANCELLABLE_TITLE: 'This booking can no longer be cancelled',
        NOT_CANCELLABLE_TEXT: 'It is already under way or has ended.',
        RIDES_FAILED_TITLE: 'Not every ride could be cancelled',
        RIDES_FAILED_TEXT: 'The provider did not accept the cancellation of vehicle {{vehicles}}. The booking stays active with the rest already cancelled: try again.',
      },

      RECEIPT: {
        TITLE: 'Booking receipt',
        PRINT: 'Print or save as PDF',
        BACK: 'Back to the booking',
        NOT_READY: 'The receipt is available once the booking is completed.',
        LOAD_ERROR: 'The receipt could not be loaded.',
        ISSUER: 'WAIIS · Group booking receipt',
        REFERENCE: 'Reference',
        COMPLETED_AT: 'Completed on',
        VEHICLE: 'Vehicle',
        SUBTOTAL: 'Vehicle amount',
        COMMISSION: 'WAIIS fee ({{pct}} %)',
        TOTAL: 'Total',
        PAYMENT: 'Payment',
        PAYMENT_PAID: 'Charged on {{date}}',
        PAYMENT_PENDING: 'Charge pending',
        PAYMENT_FAILED: 'The charge failed',
        FOOTER: 'Charged to the company wallet. WAIIS acts as intermediary for the booking; the transport is provided by authorised operators.',
      },

      SETTINGS: {
        NOTE_TITLE: 'Group booking rules',
        NOTE_TEXT: 'They apply to every company. Seats cap the passengers of each vehicle; cancellation only applies to earlier bookings, which WAIIS managed.',
        LOAD_ERROR: 'The booking settings could not be loaded.',
        CANCEL_TITLE: 'Cancellation',
        CANCEL_SUB: 'Only for earlier bookings, which WAIIS managed: when cancelling a confirmed one stops being free and what it costs afterwards.',
        FREE_HOURS: 'Free up to (hours before)',
        FREE_HOURS_HINT: 'Between 0 and 720. A requested booking can always be cancelled for free.',
        FEE_PERCENT: 'Cost afterwards (% of the maximum estimate)',
        FEE_PERCENT_HINT: 'Between 0 and 100. Only for earlier bookings.',
        SEATS_TITLE: 'Seats per vehicle',
        SEATS_SUB: 'A vehicle cannot take more passengers than the seats of its category.',
        RANGE: 'Out of range.',
        SAVE: 'Save changes',
        SAVING: 'Saving…',
        SAVED: 'Booking settings saved',
        SAVE_ERROR: 'The settings could not be saved',
        ACCEPT: 'OK',
      },

      DESK: {
        TITLE: 'Group bookings',
        SUB: 'All company bookings, from the nearest to the furthest. Vehicles are booked automatically; here you can view them and cancel them with a reason.',
        ALL_CORPORATIONS: 'All companies',
        CORPORATION_ARIA: 'Company',
        EMPTY: 'There are no bookings with these filters.',
        CANCEL: 'Cancel',
        CANCEL_TITLE: 'Cancel the booking',
        CANCEL_TEXT: 'Whatever is held is released except what the providers charge for cancelling, and the person who created it is notified with the reason.',
        CANCEL_REASON: 'Reason (the company will see it)',
        CANCEL_REASON_REQUIRED: 'Enter the reason.',
        CANCEL_DONE: 'Cancelled',
        CANCEL_SAVING: 'Cancelling…',
        ACTION_ERROR: 'The action could not be completed',
      },
      DESK_DETAIL: {
        BOOKING_ID: 'Booking ID',
        COPY_ID: 'Copy ID',
        ID_COPIED: 'Copied',
        PICKUP_META: 'Pickup {{date}}',
        OFFICE_META: 'Office {{name}}',
        CREATED_BY_META: 'Created by {{name}}',
        SECTION: {
          BOOKING: 'Booking',
          ROUTE: 'Route',
          AMOUNT: 'Amount',
          VEHICLES: 'Vehicles',
          HISTORY: 'History',
        },
        SECTION_SUB: {
          BOOKING: 'What was booked, for when and who requested it.',
          ROUTE: 'Where the group is picked up and where it goes.',
          AMOUNT: 'The estimate, the amount held in the company wallet and what was charged.',
          VEHICLES: '{{count}} × {{category}} · {{service}}',
          VEHICLES_PRODUCT: '{{count}} × {{product}}',
          HISTORY: 'What has happened to the booking, in order.',
        },
        CREATED_AT: 'Created on',
        ESTIMATE: 'Estimate',
        HELD: 'Held',
        HELD_MAX: 'Maximum held',
        COMMISSION: 'WAIIS commission',
        COMMISSION_PCT: '{{pct}} %',
        VEHICLES_AMOUNT: 'Vehicles amount',
        TOTAL: 'Total',
        CHARGED: 'Charged',
        CHARGED_AT: 'on {{date}}',
        CANCEL_FEE: 'Cancellation fee',
        VEHICLE_AMOUNT: 'Amount {{amount}}',
      },
    },
  },
};
